import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/ui/Header";
import Icon from "../../components/AppIcon";
import Button from "../../components/ui/Button";
import StoryCard from "./components/StoryCard";
import CategoryFilter from "./components/CategoryFilter";
import FeaturedStory from "./components/FeaturedStory";
import TransformationMetrics from "./components/TransformationMetrics";

const TravelerStoriesHub = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState("all");
  const [filteredStories, setFilteredStories] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const handleReadMore = (story) => {
    navigate(`/traveler-stories-hub/${story.id}`, { state: { story } });
  };

  const categories = [
    {       id: "all", name: "All Stories", icon: "BookOpen", count: 5 },
    {
      id: "overcoming-fears",
      name: "Overcoming Fears",
      icon: "Shield",
      count: 1,
    },
    {
      id: "cultural-awakening",
      name: "Cultural Awakening",
      icon: "Globe",
      count: 2,
    },
    {
      id: "spiritual-journey",
      name: "Spiritual Journey",
      icon: "Heart",
      count: 2,
    },
  ];

  const featuredStory = {
    id: "featured-1",
    title: "Five Treks with Sherpa Trekker: A Journey of a Lifetime",
    excerpt:
      "I have made several trek with Sherpatrekker! Five! Because I enjoyed so much the first one with Sherpatrekker that I would come again! Nepal is an enchanting country and all the trek I made with Sherpatrekker has been amazing! Pasang Sherpa the guide, is a true professional! His team too! Only good surprise with them!",
    featuredImage: "/assets/images/odile-servy.jpeg",
    traveler: {
      name: "Odile Servy",
      avatar: "/assets/images/odile-servy.jpeg",
      location: "France",
      profession: "Returning Trekker",
    },
    trek: "Multiple Treks",
    trekDate: "2024",
    category: "spiritual-journey",
    readTime: "5 min read",
    views: "1.2K",
    rating: 5,
    tags: [
      "Returning Client",
      "Cultural Immersion",
      "Sherpa Culture",
      "Multiple Treks",
    ],
  };

  const stories = [
    {
      id: 1,
      title: "A Family Journey Through the Langtang Valley",
      excerpt:
        "Thank you Sherpa Trekker for organizing this trip. It was a pleasure to meet you: Sanu, Pemba, Pasang's family, Fireman, Mama from the Garden Inn hotel, Maya, Khrishna and all the others. Thank you all for your smiles, your sharing, your joy, your welcome. We had a very nice trip among you.",
      featuredImage: "/assets/images/aurely-family.jpeg",
      traveler: {
        name: "Aurély & Family",
        avatar: "/assets/images/aurely-family.jpeg",
        location: "France",
      },
      trek: "Langtang Trek",
      trekDate: "2024",
      category: "cultural-awakening",
      readTime: "4 min read",
      rating: 5,
      tags: ["Family Adventure", "Sherpa Hospitality", "Cultural Immersion"],
    },
    {
      id: 2,
      title: "Safe and Unforgettable: Trekking the Annapurna Circuit",
      excerpt:
        "Pasang Sherpa is a very good trekking guide, who knows his business. Nothing to complain. I felt safe and well-protected with him during the entire trek. He has great knowledge of his country. He told me what to eat and what not and why. He showed me things that I would never seen without him. I am more than satisfied with his great service.",
      featuredImage: "/assets/images/luigi.jpeg",
      traveler: {
        name: "Luigi",
        avatar: "/assets/images/luigi.jpeg",
        location: "Italy",
      },
      trek: "Annapurna Circuit Trek",
      trekDate: "2024",
      category: "overcoming-fears",
      readTime: "4 min read",
      rating: 5,
      tags: ["Expert Guide", "Safety", "Hidden Gems", "Professional Service"],
    },
    {
      id: 3,
      title: "Three Treks, One Unforgettable Journey with Sherpa Trekker",
      excerpt:
        "I booked three treks with 'Sherpatrekker': the first was the Ghorepani Poonhill trek, followed by a climb of Pikey Peak where I experienced the sunrise with a view of Everest, and finally a trek in the Langtang Valley. Along with his meticulous planning and sense of responsibility, the good humour of Pasang and his team ensured an unforgettable trek.",
      featuredImage: "/assets/images/markus-balmer.jpeg",
      traveler: {
        name: "Markus Balmer",
        avatar: "/assets/images/markus-balmer.jpeg",
        location: "Switzerland",
      },
      trek: "Ghorepani Poonhill · Pikey Peak · Langtang Valley",
      trekDate: "2016",
      category: "spiritual-journey",
      readTime: "4 min read",
      rating: 5,
      tags: ["Multiple Treks", "Sunrise at Pikey Peak", "Professional Team", "Sherpa Hospitality"],
    },
    {
      id: 4,
      title: "Treated Like Royalty: A Tailored Trek with Pasang and His Team",
      excerpt:
        "Sherpatrekker is an excellent choice. It takes every request into account; the boss and Guide Pasang Sherpa is a very friendly and caring person. He organises the treks to perfection, and changes are no problem at all. You're treated like royalty, and he treats his team exceptionally well too.",
      featuredImage: "/assets/images/myrta-fink.jpeg",
      traveler: {
        name: "Myrta Fink",
        avatar: "/assets/images/myrta-fink.jpeg",
        location: "Germany",
      },
      trek: "Tailored Himalayan Treks",
      trekDate: "2026",
      category: "cultural-awakening",
      readTime: "4 min read",
      rating: 5,
      tags: ["Excellent Choice", "Treated Like Royalty", "Perfect Organisation", "Nepalese Culture"],
    },
  ];

  const transformationMetrics = [
    {
      icon: "TrendingUp",
      value: "100%",
      label: "Return Rate",
      description: "All clients would trek again with Sherpa Trekker",
    },
    {
      icon: "Users",
      value: "5",
      label: "Client Reviews",
      description: "Real stories from real trekkers",
    },
    {
      icon: "Target",
      value: "5★",
      label: "Perfect Rating",
      description: "Every client rated their experience 5 out of 5",
    },
    {
      icon: "Heart",
      value: "100%",
      label: "Satisfaction",
      description: "Every trekker felt safe and well cared for",
    },
  ];

  

  useEffect(() => {
    let filtered = stories;
    if (activeCategory !== "all") {
      filtered = filtered.filter((s) => s.category === activeCategory);
    }
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      filtered = filtered.filter(
        (s) =>
          s.title.toLowerCase().includes(q) ||
          s.excerpt.toLowerCase().includes(q) ||
          s.tags.some((t) => t.toLowerCase().includes(q)),
      );
    }
    setFilteredStories(filtered);
  }, [activeCategory, searchQuery]);

  return (
    <div className="min-h-screen bg-background">
      <Header />

      {/* ── Hero ── */}
      <section className="relative pt-28 lg:pt-32 overflow-hidden">
        {/* Background */}
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1600&h=700&fit=crop"
            alt="Himalayan landscape"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28 text-center text-white">
          <span className="inline-block bg-white/15 backdrop-blur-sm border border-white/20 text-white text-sm font-medium px-4 py-1.5 rounded-full mb-6">
            Real Stories · Real Transformations
          </span>
          <h1
            className="font-headline text-4xl lg:text-6xl mb-5 leading-tight text-white"
            style={{ fontWeight: 300 }}
          >
            <span style={{ color: "#c4873a" }}>Stories</span> of Transformation
          </h1>
          <p className="text-lg lg:text-xl text-white/85 max-w-2xl mx-auto mb-10 leading-relaxed">
            Real journeys, authentic experiences, and life-changing moments from
            our trekking community across the Himalayas.
          </p>

          {/* Search */}
          <div className="max-w-xl mx-auto">
            <div className="relative">
              <Icon
                name="Search"
                size={18}
                className="absolute left-4 top-1/2 -translate-y-1/2 text-text-secondary"
              />
              <input
                type="text"
                placeholder="Search stories by title, experience, or tags…"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-11 pr-4 py-3.5 rounded-xl bg-white text-foreground placeholder-text-secondary focus:outline-none focus:ring-2 focus:ring-primary shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ── Main content ── */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        {/* Transformation Metrics */}
        <TransformationMetrics metrics={transformationMetrics} />

        {/* Featured Story */}
        <FeaturedStory story={featuredStory} onReadMore={handleReadMore} />

        {/* Stories section header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
          <div>
            <h2
              className="text-2xl font-headline text-foreground"
              style={{ fontWeight: 300 }}
            >
              <span style={{ color: "#2d5016" }}>Traveler</span> Stories
            </h2>
            <p className="text-text-secondary text-sm mt-1">
              {filteredStories.length} stor
              {filteredStories.length === 1 ? "y" : "ies"} found
            </p>
          </div>
        </div>

        {/* Category Filter */}
        <CategoryFilter
          categories={categories}
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
        />

        {/* Stories Grid */}
        {filteredStories.length > 0 ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7 mb-16">
            {filteredStories.map((story) => (
              <StoryCard
                key={story.id}
                story={story}
                onReadMore={handleReadMore}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-20 text-text-secondary">
            <Icon name="Search" size={40} className="mx-auto mb-4 opacity-30" />
            <p className="text-lg font-medium">No stories found</p>
            <p className="text-sm mt-1">
              Try a different category or search term
            </p>
          </div>
        )}

        {/* CTA */}
        <section className="relative overflow-hidden rounded-2xl">
          <img
            src="https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=1200&h=400&fit=crop"
            alt="Himalayan trek"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-amber-900/60 to-amber-800/60" />
          <div className="relative text-center text-white px-8 py-14 lg:py-16">
            <h2
              className="font-headline text-3xl lg:text-4xl mb-4 text-white"
              style={{ fontWeight: 300 }}
            >
              Ready to Write Your{" "}
              <span style={{ color: "#f0d6a0" }}>Own Story</span>?
            </h2>
            <p className="text-lg text-white/90 mb-8 max-w-xl mx-auto">
              Join our community of adventurers and create your own
              transformation story in the Himalayas. Every journey begins with a
              single step.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Button
                variant="default"
                size="lg"
                iconName="Calendar"
                iconPosition="left"
                onClick={() => navigate("/booking-consultation-center")}
                className="bg-white text-primary hover:bg-white/90 font-semibold"
              >
                Book Your Trek
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="MessageCircle"
                iconPosition="left"
                onClick={() => navigate("/booking-consultation-center")}
                className="border-white/40 text-white hover:bg-white/10"
              >
                Speak with Expert
              </Button>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-foreground text-white mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 mountain-gradient rounded-lg flex items-center justify-center mr-3 overflow-hidden">
                  <img
                    src="/assets/images/logo.jpeg"
                    alt="Sherpa Trekker Logo"
                  />
                </div>
                <div>
                  <span className="text-xl font-headline font-bold block">
                    Sherpa Trekker
                  </span>
                  <span className="text-xs text-white/60">
                    Where Adventure Meets Authenticity
                  </span>
                </div>
              </div>
              <p className="text-white/70 mb-4 max-w-md text-sm leading-relaxed">
                Creating transformative Himalayan experiences that honour Sherpa
                culture while fostering genuine connections between travellers
                and mountain communities.
              </p>
              <div className="flex space-x-4">
                <Icon
                  name="Facebook"
                  size={20}
                  className="text-white/60 hover:text-white cursor-pointer"
                />
                <Icon
                  name="Instagram"
                  size={20}
                  className="text-white/60 hover:text-white cursor-pointer"
                />
                <Icon
                  name="Twitter"
                  size={20}
                  className="text-white/60 hover:text-white cursor-pointer"
                />
                <Icon
                  name="Youtube"
                  size={20}
                  className="text-white/60 hover:text-white cursor-pointer"
                />
              </div>
            </div>

            <div>
              <h3 className="font-headline font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-white/70 text-sm">
                <li>
                  <a href="/trek-discovery-hub" className="hover:text-white">
                    Discover Treks
                  </a>
                </li>
                <li>
                  <a href="/activities" className="hover:text-white">
                    Activities & Tours
                  </a>
                </li>
                <li>
                  <a href="/nepal-info" className="hover:text-white">
                    Nepal Travel Info
                  </a>
                </li>
                <li>
                  <a href="/sherpa-guide-profiles" className="hover:text-white">
                    Our Guides
                  </a>
                </li>
                <li>
                  <a
                    href="/booking-consultation-center"
                    className="hover:text-white"
                  >
                    Book Consultation
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-headline font-semibold mb-4">Contact</h3>
              <ul className="space-y-2 text-white/70 text-sm">
                <li className="flex items-center gap-2">
                  <Icon name="Phone" size={15} />
                  +977-9851157213
                </li>
                <li className="flex items-center gap-2">
                  <Icon name="Mail" size={15} />
                  imsherpatrekker@gmail.com
                </li>
                <li className="flex items-center gap-2">
                  <Icon name="MapPin" size={15} />
                  Thamel, Kathmandu, Nepal
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/20 mt-8 pt-8 text-center text-white/50 text-sm">
            <p>
              &copy; {new Date().getFullYear()} Sherpa Trekker. All rights
              reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TravelerStoriesHub;
